export const configApi = {
    API_URL: process.env.NEXT_PUBLIC_API_URL,
    API_PUBLIC_DOMAIN: process.env.NEXT_PUBLIC_DOMAIN,
    YANDEX_STORAGE_URL: process.env.NEXT_PUBLIC_YANDEX_STORAGE_URL
};